import React, { Suspense, useState } from 'react';
import { useGlobalContext } from 'GlobalState/Context/GlobalContext';

// Form
import ClientsForm from 'components/Form/Manage/ManageClientsForm/ClientsForm';

// Table
import TableManageClients from 'components/Tables/Mangage/TableClients/TableClients';
import SkeletonTable from 'components/LoadingSkeletons/SkeletonTable/SkeletonTable';
import ExternalStateCheckbox from 'components/Checkbox/ExternalStateCheckbox';

// UI
import Card from 'components/Card/Card';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import SearchFilter from 'components/Tables/SearchField';
import Button from 'components/Button/Button';

import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';

const TabClients = () => {
  const { globalDispatch } = useGlobalContext();
  const [shouldShowInactive, setShouldShowInactive] = useState(false);

  const handleAddPopup = () => {
    globalDispatch({
      type: 'setModalContent',
      payload: (
        <Suspense fallback={<div>Loading</div>}>
          <ClientsForm heading="Add a Client" type="create" />
        </Suspense>
      ),
    });
  };

  return (
    <>
      <Card
        title="Clients overview"
        leftAdditional={
          <label>
            Show Inactive
            <ExternalStateCheckbox
              setIsChecked={setShouldShowInactive}
              isChecked={shouldShowInactive}
            />
          </label>
        }
        headerAdditional={
          <FlexContainer spaceX="children-x-10px">
            <SearchFilter />
            <Button
              clicked={handleAddPopup}
              text="Add"
              type="button-primary"
              additionalInlineStyles={{
                minWidth: '6.25em',
                paddingTop: '0.375em',
                paddingBottom: '0.375em',
              }}
            />
          </FlexContainer>
        }
      >
        <ErrorBoundary>
          <Suspense fallback={<SkeletonTable countTableBodyRows={20} />}>
            <TableManageClients shouldShowInactive={shouldShowInactive} />
          </Suspense>
        </ErrorBoundary>
      </Card>
    </>
  );
};

export default TabClients;
